<a href="{{ href }}" target="_blank" [attr.data-download-title]="title" title="{{ title }}" data-btn-text="Download" class="btn btn--download">Download
  <svg class="download-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11.3">
      <g transform="translate(-377.9 -2532.5)">
          <path class="download-icon-1" d="M412.5,194.5l5,5-5,5" transform="translate(583 2123) rotate(90)" />
          <line class="download-icon-2" y1="8" transform="translate(383.5 2532.5)" />
          <line class="download-icon-3" x2="11" transform="translate(377.9 2543.3)" />
      </g>
  </svg>
</a>
